import * as Yup from 'yup';

export const validation = Yup.object({
  selected: Yup.object().test(
    'selected',
    'investor_investments_auto_sale_modal_selected_error',
    function test(value) {
      return Object.keys(value || {}).some(
        (key) => value[key] !== undefined && value[key] !== false
      );
    }
  ),
  search: Yup.number()
    .required()
    .test('search', (value) => value > 0),
});
